import { useEffect } from 'react'
import isEmpty from 'lodash/isEmpty'

import { useAppDispatch, useAppSelector } from 'app/hooks'
import {
  availableLicensesSelector,
  licensesGroupsSelector,
  selectedHomeSelector,
} from 'features/home/selectors'

import HomeLicensesGroupsTable from './HomeLicensesGroupsTable'
import { SpinnerCentered } from 'components/Loader'
import {
  AvailableLicensesContainer,
  AvailableLicensesHeader,
  Title,
  StyledInfo,
} from './styles'
import { HomeNoLicenses } from '../styles'
import {
  fetchAvailableLicensesThunk,
  homeAvailableLicensesListActions,
} from '../slice'

function AvailableLicenses() {
  const dispatch = useAppDispatch()
  const currentHome = useAppSelector(selectedHomeSelector.data)
  const isFetching = useAppSelector(availableLicensesSelector.isFetching)
  const isError = useAppSelector(availableLicensesSelector.error)
  const licensesGroups = useAppSelector(licensesGroupsSelector)

  useEffect(() => {
    if (currentHome?.id && currentHome?.domainId) {
      dispatch(
        fetchAvailableLicensesThunk(currentHome.id, currentHome.domainId)
      )
    }

    return () => {
      dispatch(homeAvailableLicensesListActions.clear())
    }
  }, [dispatch, currentHome?.id, currentHome?.domainId])

  if (!currentHome) {
    return null
  }

  return (
    <AvailableLicensesContainer>
      <AvailableLicensesHeader>
        <Title>Available Licenses</Title>
      </AvailableLicensesHeader>
      {isError && <StyledInfo>Something went wrong</StyledInfo>}

      {isFetching && isEmpty(licensesGroups) && <SpinnerCentered />}

      {isEmpty(licensesGroups) && !isFetching && !isError ? (
        <HomeNoLicenses>No Available Licenses</HomeNoLicenses>
      ) : (
        <HomeLicensesGroupsTable licensesGroups={licensesGroups} />
      )}
    </AvailableLicensesContainer>
  )
}

export default AvailableLicenses
